import { VStack } from '@genial/components';
import { Spacing } from '@genial/design-tokens';
import React from 'react';

import {
  TableHeadContainer,
  TableHeadItem,
  TableHeadItemRecurse,
} from '../../../../../../../../components/TableHead';
import { useGlobalProductContext } from '../../../../contexts';
import { useGlobalProductController } from '../../../../hooks';

export interface ProductTableHeadProps {
  recurses: TableHeadItemRecurse[];
}

export const ProductTableHead: React.FC<ProductTableHeadProps> = ({ recurses }) => {
  const { orderBy, product } = useGlobalProductContext();
  const { handleAutoOrderBy } = useGlobalProductController();

  const handlePress = (value?: string) => {
    if (!value) {
      return;
    }
    handleAutoOrderBy(value);
  };

  if (product.hideTableHead) {
    return <></>;
  }

  return (
    <VStack space={Spacing['inline.nano']}>
      <TableHeadContainer px={Spacing['inline.xxxs']}>
        {recurses.map((item, index) => (
          <TableHeadItem
            key={`${item.title}-${index}`}
            {...item}
            value={item.orderValue}
            orderBy={orderBy}
            onPress={() => handlePress(item.orderValue as string)}
          />
        ))}
      </TableHeadContainer>
    </VStack>
  );
};
